import React, { useState } from "react";
import EndPoints from "../../Api/EndPoints";
import Colors from "../../Constants/Colors";
const PrintQuestionPaperModal = ({
    isOpen,
    onClose,
    testScheduleId = 1,
    token,
    fileName,
}) => {
    const [isLoading, setIsLoading] = useState(false);
    const [selectedSet, setSelectedSet] = useState("A");

    if (!isOpen) return null;

    const fetchAndDownload = async () => {
        try {
            setIsLoading(true);

            const url = `${EndPoints.PDF_DOWNLOAD_TEST_SCHEDULE}?test_schedule_id=${testScheduleId}&set_name=${selectedSet}`;

            const response = await fetch(url, {
                method: "GET",
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            if (!response.ok) throw new Error("Failed to download PDF");

            const blob = await response.blob();
            const downloadUrl = window.URL.createObjectURL(blob);

            const link = document.createElement("a");
            link.href = downloadUrl;

            let finalFileName = "";

            // if fileName exists → append set
            if (fileName) {
                // remove .pdf if already present to avoid double extension
                const baseName = fileName.replace(/\.pdf$/i, "");
                finalFileName = `${baseName}_${selectedSet}.pdf`;
            } else {
                // fallback
                finalFileName = `test_${testScheduleId}_${selectedSet}.pdf`;
            }

            link.download = finalFileName;

            document.body.appendChild(link);
            link.click();

            link.remove();
            window.URL.revokeObjectURL(downloadUrl);
        } catch (err) {
            console.error(err);
            alert("Error downloading PDF");
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div style={styles.overlay} onClick={onClose}>
            <div style={styles.modal} onClick={(e) => e.stopPropagation()}>

                {/* Header */}
                <div style={styles.header}>
                    <h2 style={styles.title}>Question Paper Print Preview</h2>
                    <button style={styles.closeButton} onClick={onClose}>
                        ✕
                    </button>
                </div>

                {/* Body */}
                <div style={styles.body}>
                    <div style={styles.box}>
                        <div style={styles.section}>
                            <h4 style={styles.label}>Select Set</h4>

                            <div style={styles.radioGroup}>
                                {["A", "B", "C", "D"].map((set) => (
                                    <label key={set} style={styles.radioLabel}>
                                        <input
                                            type="radio"
                                            name="set"
                                            value={set}
                                            checked={selectedSet === set}
                                            onChange={() => setSelectedSet(set)}
                                            disabled={isLoading}
                                        />
                                        <span>{set}</span>
                                    </label>
                                ))}
                            </div>
                        </div>
                    </div>

                    {/* Footer */}
                    <div style={styles.footer}>
                        <button
                            onClick={fetchAndDownload}
                            disabled={isLoading}
                            style={{
                                ...styles.printButton,
                                opacity: isLoading ? 0.6 : 1,
                            }}
                        >
                            {isLoading ? "Loading..." : "🖨 DOWNLOAD"}
                        </button>
                    </div>
                </div>

            </div>
        </div>
    );
};

export default PrintQuestionPaperModal;

/* ================= STYLES ================= */

const styles = {
    overlay: {
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        background: Colors.color2, // semi transparent overlay
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 90,
    },

    modal: {
        width: "600px",
        borderRadius: "10px",
        overflow: "hidden",
        background: Colors.color14, // main modal bg
        border: `1px solid ${Colors.color11}`,

    },

    /* 🔥 HEADER */
    header: {
        background: Colors.color7, // header grey
        padding: "15px 20px",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        borderBottom: `1px solid ${Colors.color9}`,
    },

    title: {
        margin: 0,
        fontSize: "16px",
        fontWeight: "600",
        color: Colors.color1,
    },

    closeButton: {
        border: "none",
        background: "transparent",
        fontSize: "18px",
        cursor: "pointer",
        color: Colors.color3,
        fontWeight: "900",
    },

    /* 🔥 BODY */
    body: {
        padding: "20px",
        background: Colors.color14,
    },

    box: {
        background: Colors.color4,
        border: `1px solid ${Colors.color9}`,
        borderRadius: "8px",
        padding: "20px",
    },

    section: {
        marginBottom: "5px",
    },

    label: {
        fontSize: "14px",
        fontWeight: "600",
        marginBottom: "15px",
        color: Colors.color1,
    },

    radioGroup: {
        display: "flex",
        gap: "40px",
        alignItems: "center",
    },

    radioLabel: {
        display: "flex",
        alignItems: "center",
        gap: "6px",
        fontSize: "16px",
        fontWeight: "bold",
        cursor: "pointer",
        color: Colors.color1,
    },

    footer: {
        marginTop: "20px",
        display: "flex",
        justifyContent: "flex-end",
    },

    printButton: {
        padding: "10px 20px",
        borderRadius: "8px",
        border: `1px solid ${Colors.color3}`,
        background: Colors.color14,
        cursor: "pointer",
        fontWeight: "bold",
        color: Colors.color1,
    },
};